var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCommentDisabled(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: `url(#${_id})`,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#707175"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.456 5.403h-2.13c-2.353 0-4.26 1.882-4.26 4.203 0 3.415 3.727 4.991 6.39 6.042v-1.839c2.353 0 4.26-1.882 4.26-4.203 0-2.321-1.907-4.203-4.26-4.203zm0 7.355H6.391v1.303c-2.949-1.32-4.26-2.558-4.26-4.455 0-1.741 1.43-3.152 3.195-3.152h2.13c1.142 0 2.197.6 2.767 1.576.571.975.571 2.177 0 3.152a3.203 3.203 0 01-2.767 1.576zM14.528 13.367h-2.13c-2.353 0-4.26 1.881-4.26 4.203 0 3.415 3.728 4.991 6.39 6.042v-1.839c2.353 0 4.26-1.882 4.26-4.203 0-2.322-1.907-4.203-4.26-4.203zm0 7.355h-1.065v1.303c-2.949-1.321-4.26-2.559-4.26-4.456 0-1.74 1.43-3.152 3.195-3.152h2.13c1.142 0 2.197.6 2.768 1.576.57.975.57 2.177 0 3.152a3.203 3.203 0 01-2.768 1.577zM18.424 2.473h-1.99c-2.2 0-3.982 1.759-3.982 3.928 0 2.17 1.782 3.929 3.981 3.929v1.718c2.489-.982 5.973-2.455 5.973-5.647 0-2.17-1.783-3.928-3.982-3.928zm-.996 6.875h-.995a2.994 2.994 0 01-2.587-1.474 2.912 2.912 0 010-2.946 2.994 2.994 0 012.587-1.473h1.99c1.65 0 2.986 1.32 2.986 2.946 0 1.773-1.225 2.93-3.981 4.164V9.348z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCommentDisabled;